import { API_BASE_URL } from "@constants/urls";
import authAxios from "@helpers/lib/axios";
import type { ReportDetails } from "@memorang/types/src/session/report";
import type { GetReportRequest } from "./types";
export async function getReport(
	request: GetReportRequest,
): Promise<ReportDetails> {
	const { data } = await authAxios.post<{ data: ReportDetails }>(
		`${API_BASE_URL}/sessions-v2/v2/reports`,
		request,
	);
	return data.data;
}
